export {};

declare global {
    interface Array<T> {
        mapAsync<U>(mapFn: (value: T, index: number, array: T[]) => Promise<U>): Promise<U[]>;
    }
}

if (!Array.prototype.mapAsync) {
    Array.prototype.mapAsync = async function <U, T>(
        mapFn: (value: T, index: number, array: T[]) => Promise<U>,
    ): Promise<U[]> {
        return await Promise.all(
            (this as T[]).map(async (v, i, a): Promise<U> => {
                return await mapFn(v, i, a);
            }),
        );
    };
}
